import { Component, ChangeDetectionStrategy, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigService } from '@src/app/servicios/config/config.service';

@Component({
  selector: 'app-google-news-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './google-news-banner.component.html',
  styleUrls: ['./google-news-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GoogleNewsBannerComponent implements OnInit {
  googleNewsUrl = 'https://google.com/preferences/source?q=';
  configService = inject(ConfigService);
  domainWithoutTld = '';
  
  ngOnInit() {
    const globals = this.configService.getConstantesGlobales();
    let domain = globals?.siteDomain || '';
    domain = domain.replace(/^(https?:\/\/)?(www\.)?/, ""); // Clean domain
    this.googleNewsUrl += domain;
    
    // Extract domain without .com or .es
    this.domainWithoutTld = domain.replace(/\.[^/.]+$/, "");
    
    // Capitalize the first letter for display (e.g. tribunasalamanca -> Tribunasalamanca)
    // Sometimes it's better to leave it as is if it's a domain name, or just use siteName.
    // The user asked for "mi dominio sin .com", so we give them that.
    if(this.domainWithoutTld) {
        // Option to just keep it lowercase, or capitalize: 
        // this.domainWithoutTld = this.domainWithoutTld.charAt(0).toUpperCase() + this.domainWithoutTld.slice(1);
    }
  }
}
